<div class="row" *ngIf='bulletins != null'>
  <div class="col-md-12">
    <p-table [value]="bulletins"
             [rows]="5"
             [paginator]="true"
             [pageLinks]="5"
             [reorderableColumns]="true"
             exportFilename="Bulletins"
             #bulletinsTable
             sortField="date">

      <ng-template pTemplate="caption">
        <div class="ui-helper-clearfix" style="display: flex; flex-direction: row; align-self: flex-end">
          <button type="button"
                  pButton
                  class="risksponge-button"
                  icon="pi pi-file-excel"
                  iconPos="left"
                  (click)="bulletinsTable.exportCSV()">
          </button>
          <button type="button"
                  pButton
                  class="risksponge-button"
                  icon="pi pi-pencil"
                  iconPos="left"
                  (click)="createBulletin()"
                  style="float:right"
                  *ngIf="canManageBulletins">
          </button>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th>Area</th>
          <th>Item</th>
          <th>Type</th>
          <th>Date</th>
          <th style="width: 10em;"></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
        <tr>
          <td>
            <span *ngFor="let area of item.areaNames; let isLast=last">{{area}}{{isLast ? '' : ', '}}</span>
          </td>
          <td>{{item.name}}</td>
          <td>{{item.type}}</td>
          <td>{{item.date | date : 'shortDate'}}</td>
          <td>
            <button type="button"
                    pButton
                    class="risksponge-button"
                    (click)="editBulletin(item)"
                    icon="pi pi-pencil">
            </button>
            <button type="button"
                    pButton
                    class="risksponge-button"
                    (click)="deleteBulletin(item.bulletinId)"
                    icon="fa-close">
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
